<div #fullscreenContainer>
  <div (click)="fullscreen()" style=" height: 50px; width: 50px; position: absolute"></div>
  <router-outlet></router-outlet>
</div>
